import {Box, Card, type CardProps} from '@mantine/core'
import type {ReactNode} from 'react'

type Props = {
  controls: ReactNode
} & Omit<CardProps, 'style'>

export const ActionCard = ({controls, children, p = 'xs', ...rest}: Props) => {
  return (
    <Card p={p} style={{position: 'relative'}} {...rest}>
      <Box pr={p} pt={p} style={{position: 'absolute', top: 0, right: 0, zIndex: 1, display: 'flex', gap: 5}}>
        {controls}
      </Box>
      {children}
    </Card>
  )
}
